import React, { Component } from 'react';
import propTypes from 'prop-types';
import { DAY_EVENT_HEIGHT } from '~/Redux/Modules/Events';

import StyledEvent from '~/Containers/Pages/Calendar/StyledEvent/StyledEvent';

import './CalendarEvents.scss';

class CalendarEvents extends Component {
  handleShowMore = () => {
    const { currentAllDayEvents, events, day } = this.props;

    const currentDay = day.weekday();
    if (!currentAllDayEvents || !currentAllDayEvents.length) return false;

    return currentAllDayEvents.map((eventRow, rowIndex) => {
      if (eventRow[currentDay]) {
        let event =
          events.find(event => {
            return (
              event.id === eventRow[currentDay].id &&
              (!event.repeats || event.startInZone.isSame(this.props.day, 'day'))
            );
          }) || events.find(event => event.id === eventRow[currentDay].id);

        const isLastSlot =
          typeof eventRow[currentDay + 1] === 'undefined' ||
          eventRow[currentDay + 1] === null ||
          eventRow[currentDay + 1].id !== event.id ||
          eventRow[currentDay + 1].startForRecurrence !== event.startForRecurrence;

        const lastSlotStyle = isLastSlot ? { width: 'calc(100% - 0.5rem)' } : {};
        const style = {
          // top: (rowIndex > 0) ? (20 * rowIndex + rowIndex) : (20 * rowIndex),
          ...lastSlotStyle,
          key: event.id,
        };
        return (
          <StyledEvent
            key={rowIndex}
            event={event}
            className="all-day-event"
            style={style}
            clickBehavior={this.props.clickBehavior}
          />
        );
      }
    });
  };

  handleShowLess = () => {
    const { currentAllDayEvents, events, day, moreLength } = this.props;
    const currentDay = this.props.day.weekday();
    if (!currentAllDayEvents || !currentAllDayEvents.length) return false;
    return currentAllDayEvents.slice(0, moreLength).map((eventRow, rowIndex) => {
      if (eventRow[currentDay]) {
        let event =
          events.find(event => {
            return (
              event.id === eventRow[currentDay].id &&
              (!event.repeats || event.startInZone.isSame(this.props.day, 'day'))
            );
          }) || events.find(event => event.id === eventRow[currentDay].id);

        const endsSameDay = event.startInZone.isSame(event.endInZone, 'day');

        const isFirstSlot =
          typeof eventRow[currentDay - 1] === 'undefined' ||
          eventRow[currentDay - 1] === null ||
          eventRow[currentDay - 1]?.id !== event.id ||
          eventRow[currentDay - 1]?.startForRecurrence !== event.startForRecurrence ||
          endsSameDay;
        const isLastSlot =
          typeof eventRow[currentDay + 1] === 'undefined' ||
          eventRow[currentDay + 1] === null ||
          eventRow[currentDay + 1]?.id !== event.id ||
          eventRow[currentDay + 1]?.startForRecurrence !== event.startForRecurrence ||
          endsSameDay;

        const isFirstOfWeek = day.weekday() === 0;
        const lastSlotStyle = isLastSlot ? { width: 'calc(100% - 0.5rem)' } : {};
        const style = {
          // top: (rowIndex > 0) ? (20 * rowIndex + rowIndex) : (20 * rowIndex),
          ...lastSlotStyle,
          key: event.id,
        };
        return (
          <StyledEvent
            key={rowIndex}
            event={event}
            className="all-day-event"
            style={style}
            day={this.props.day}
            showSummary={isFirstSlot || isFirstOfWeek}
            clickBehavior={this.props.clickBehavior}
          />
        );
      } else {
        return (
          <div
            key={rowIndex}
            className="event-placeholder styled-event"
            style={{ height: DAY_EVENT_HEIGHT }}
          />
        );
      }
    });
  };

  render() {
    const { expanded } = this.props;

    return (
      <div className="rendered-events">
        {expanded ? this.handleShowMore() : this.handleShowLess()}
      </div>
    );
  }
}

CalendarEvents.propTypes = {
  expanded: propTypes.bool,
  currentAllDayEvents: propTypes.array,
  events: propTypes.array,
  day: propTypes.object,
  clickBehavior: propTypes.func,
  moreLength: propTypes.number,
};

export default CalendarEvents;
